import { partnerProductOrderItemPageState } from "@/atoms/item/partner-product-order-item-page-state";
import { pageNumberState } from "@/atoms/order/page-number-state";
import { DEBOUNCE_TIME } from "@/common/constant/debounce-time";
import { initPage } from "@/common/constant/init-page";
import { OrderItemSortType } from "@/common/enum/order-item-sort";
import { PaginationSize } from "@/common/enum/pagination-size";
import { PartnerProductOrderBar } from "@/components/bar/PartnerProductOrderBar";
import { PartnerProductOrderHeader } from "@/components/header/PartnerProductOrderHeader";
import { PartnerProductOrderCartPanel } from "@/components/panel/PartnerProductOrderCartPanel";
import { PartnerProductOrderPageModalPanel } from "@/components/panel/PartnerProductOrderPageModalPanel";
import { PartnerProductOrderTable } from "@/components/table/partner-product-order-table/PartnerProductOrderTable";
import { itemService } from "@/services/item-service";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { profileState } from "../../atoms/user/profile-state";
import { ItemPagePartnerPayload } from "../../types/item/payload/item-page-payload";

export const PartnerOrderPage = () => {
  const profile = useRecoilValue(profileState);
  const [searchItemName, setSearchItemName] = useState<string>("");
  const [itemSortType, setItemSortType] = useState<OrderItemSortType>(
    OrderItemSortType.ALL
  );
  const [page, setPage] = useRecoilState<BasePageDto<ItemDetailDto>>(
    partnerProductOrderItemPageState
  );
  const [categoryIds, setCategoryIds] = useState<number[]>([]);
  const [isStar, setIsStar] = useState<boolean>(false);
  // const [pageNumber, setPageNumber] = useRecoilState(pageNumberState);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchItemName(event.target.value);
  };

  const handleSortChange = (sortType: OrderItemSortType) => {
    setItemSortType(sortType);
  };

  const handleCategoryChange = (categoryIds: number[]) => {
    setCategoryIds(categoryIds);
  };

  const getPage = async (input: ItemPagePartnerPayload) => {
    try {
      const response = await itemService.getPagePartner(profile.id, input);
      setPage(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [pageNumber, setPageNumber] = useRecoilState(pageNumberState);

  const getPageDebounce = useCallback(
    debounce(async (input) => {
      await getPage(input);
    }, DEBOUNCE_TIME),
    []
  );

  useEffect(() => {
    const payload = {
      page: pageNumber,
      size: PaginationSize.SIZE_12,
      name: searchItemName,
      orderType: itemSortType,
      categoryIds: categoryIds,
      isStar: isStar,
    };
    getPageDebounce(payload);
  }, [pageNumber]);

  useEffect(() => {
    const payload = {
      page: 1,
      size: PaginationSize.SIZE_12,
      name: searchItemName,
      orderType: itemSortType,
      categoryIds: categoryIds,
      isStar: isStar,
    };
    setPageNumber(1);
    getPageDebounce(payload);
  }, [searchItemName, itemSortType, categoryIds, isStar]);

  useEffect(() => {
    return () => {
      setPage(initPage);
    };
  }, []);

  return (
    <div className="flex justify-center w-full h-[100vh-64px] overflow-x-scroll bg-grayscale-contrast-2">
      <div className="flex gap-[24px]">
        <div className="flex flex-col w-[1112px]">
          <PartnerProductOrderHeader />
          <PartnerProductOrderBar
            totalElements={page.totalElements}
            searchItemName={searchItemName}
            orderItemSortType={itemSortType}
            isStar={isStar}
            handleSearchChange={handleSearchChange}
            handleCategoryChange={handleCategoryChange}
            handleSortChange={handleSortChange}
            setIsStar={setIsStar}
          />
          {/* 테이블맨 */}
          <PartnerProductOrderTable />
        </div>
        {/* 장바구니맨 */}
        <PartnerProductOrderCartPanel />
      </div>
      <PartnerProductOrderPageModalPanel />
    </div>
  );
};
